module.exports = __webpack_public_path__ + "static/media/cct.feda9ec3.png";